import React from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, ListItemIcon, ListItemText, ListSubheader } from '@material-ui/core';
import FileIcon from '@material-ui/icons/AttachFileTwoTone';

const BoardPostAttachments = ({ files }) => {
  return (
    <List dense style={{ maxWidth: 300 }} subheader={<ListSubheader disableGutters>Załączniki</ListSubheader>} disablePadding>
      {files.map(file => (
        <ListItem button key={file.id} onClick={() => window.open(file.url, '_blank')} disableGutters>
          <ListItemIcon>
            <FileIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={file.name} />
        </ListItem>
      ))}
    </List>
  );
};

BoardPostAttachments.propTypes = {
  files: PropTypes.array.isRequired,
};

export default BoardPostAttachments;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/board/BoardPostAttachments.js